import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Home";
import PotatoCurry from "./PotatoCurry";
import Meals from "./Meals";
import MushroomCurry from "./MushroomCurry";
import MintMojito from "./MintMojito";
import CharredCornSalad from "./CharredCornSalad";
import EggInAHoleSandwich from "./EggInAHoleSandwich";
import WatermelonSorbet from "./WatermelonSorbet";
import MangoLassi from "./Mango_Lassi";
import AamPanna from "./AamPanna";
import VirginMuskmelonMojito from "./VirginMuskmelonMojito";
import VanillaFrappe from "./VanillaFrappe";
import Games from "./Games";
import OfflineGames from "./OfflineGames";
import Math from "./Math";
import Drawing from "./Drawing";
import VivaanWebDevelopment from "./VivaanWebDevelopment";
import BusinessCard from "./BusinessCard";
import CarGame from "./Car_game";
import SpaceDefenders from "./space_defenders";
import TicTacToe from "./tic_tac_toe";
import Areas from "./Areas";
import EvenOrOdd from "./Even_or_odd";
import Factorial from "./Factorial";
import LCM from "./LCM";
import PrimeNumbers from "./Prime_numbers";
import Man from "./man";
import HappyDiwali from "./happy_diwali";
import IndiaFlag from "./india_flag";
import Keyboard from "./keyboard";
import Stickman from "./stickman";
import NewYear from "./new_year";
import RainbowTurtle from "./rainbow_turtle";
import Robot from "./robot";
import Snacks from "./Snacks";
import Drinks from "./Drinks";
import Pop from "./Pop";
import HindiSongs from "./HindiSongs";
import FavoriteSongs from "./FavoriteSongs";
import Senorita from "./Senorita";
import Believer from "./Believer";
import ShapeOfYou from "./ShapeOfYou";
import JeeLeZara from "./JeeLeZara";
import Pasoori from "./Pasoori";
import SandeseAateHai from "./SandeseAateHai";
import LetMeDownSlowly from "./LetMeDownSlowly";
import GulaabiAankhen from "./GulaabiAankhen";
import Interstellar from "./Interstellar";
import Saiyaara from "./Saiyaara";
import KalHoNaHo from "./KalHoNaHo";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndConditions from "./TermsAndConditions";
import Footer from "./Footer";
import VelvetyWhiteBeanTomatoStew from "./Velvety_white_bean_tomato_stew";
import Puff from "./puff";
import TofuWrap from "./TofuWrap";
import BananaPancakes from "./BananaPancakes";
import IdliPlatter from "./IdliPlatter";
import MixVegetableCurry from "./MixVegetableCurry";
import ChilliButterPasta from "./ChilliButterPasta";
import KeyLimePie from "./KeyLimePie";
import MasalaChai from "./MasalaChai";
import VegetableCutlet from "./VegetableCutlet";
import VanillaMilkshake from "./VanillaMilkshake";
import VanillaIceCream from "./VanillaIceCream";
import MangoPuddingWeikfield from "./MangoPuddingWeikfield";
import TaskManager from "./TaskManager";
import ChoreVault from "./ChoreVault";
import SalesDashboard from "./SalesDashboard";
import ChatPage from "./chat/ChatPage";
import QuizPopz from "./QuizPopz";
import Abacus from "./Abacus";
import HighQualityGames from "./HighQualityGames";
import NotFound from "./NotFound";
import "./App.css";
import "./RecipeExtras.css";

function AppFrame() {
  const location = useLocation();
  const isChat = location.pathname.startsWith("/chat");
  const isQuizpopz = location.pathname.startsWith("/quizpopz");
  const isAbacus = location.pathname.startsWith("/abacus");

  return (
    <div className={isChat ? "App chat-app-route" : "App"}>
        <div className="main-content">
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/potato-curry" element={<PotatoCurry />} />
            <Route path="/meals" element={<Meals />} />
            <Route path="/mushroom-curry" element={<MushroomCurry />} />
            <Route path="/mint-mojito" element={<MintMojito />} />
            <Route path="/charred-corn-salad" element={<CharredCornSalad />} />
            <Route path="/egg-in-a-hole-sandwich" element={<EggInAHoleSandwich />} />
            <Route path="/watermelon-sorbet" element={<WatermelonSorbet />} />
            <Route path="/mango-lassi" element={<MangoLassi />} />
            <Route path="/aam-panna" element={<AamPanna />} />
            <Route path="/virgin-muskmelon-mojito" element={<VirginMuskmelonMojito />} />
            <Route path="/vanilla-frappe" element={<VanillaFrappe />} />
            <Route path="/games" element={<Games />} />
            <Route path="/offline-games" element={<OfflineGames />} />
            <Route path="/car-game" element={<CarGame />} />
            <Route path="/space-defenders" element={<SpaceDefenders />} />
            <Route path="/tic-tac-toe" element={<TicTacToe />} />
            <Route path="/math" element={<Math />} />
            <Route path="/web-development" element={<VivaanWebDevelopment />} />
            <Route path="/business-card" element={<BusinessCard />} />
            <Route path="/areas" element={<Areas />} />
            <Route path="/even-or-odd" element={<EvenOrOdd />} />
            <Route path="/factorial" element={<Factorial />} />
            <Route path="/lcm" element={<LCM />} />
            <Route path="/prime-numbers" element={<PrimeNumbers />} />
            <Route path="/drawing" element={<Drawing />} />
            <Route path="/man" element={<Man />} />
            <Route path="/happy_diwali" element={<HappyDiwali />} />
            <Route path="/india_flag" element={<IndiaFlag />} />
            <Route path="/keyboard" element={<Keyboard />} />
            <Route path="/stickman" element={<Stickman />} />
            <Route path="/new_year" element={<NewYear />} />
            <Route path="/rainbow_turtle" element={<RainbowTurtle />} />
            <Route path="/robot" element={<Robot />} />
            <Route path="/snacks" element={<Snacks />} />
            <Route path="/drinks" element={<Drinks />} />
            <Route path="/pop" element={<Pop />} />
            <Route path="/hindi_songs" element={<HindiSongs />} />
            <Route path="/favorite_songs" element={<FavoriteSongs />} />
            <Route path="/senorita" element={<Senorita />} />
            <Route path="/believer" element={<Believer />} />
            <Route path="/shapeofyou" element={<ShapeOfYou />} />
            <Route path="/jee-le-zara" element={<JeeLeZara />} />
            <Route path="/pasoori" element={<Pasoori />} />
            <Route path="/sandese-aate-hai" element={<SandeseAateHai />} />
            <Route path="/letmedownslowly" element={<LetMeDownSlowly />} />
            <Route path="/gulaabi-aankhen" element={<GulaabiAankhen />} />
            <Route path="/interstellar" element={<Interstellar />} />
            <Route path="/saiyaara" element={<Saiyaara />} />
            <Route path="/kal-ho-na-ho" element={<KalHoNaHo />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/velvety_white_bean_tomato_stew" element={<VelvetyWhiteBeanTomatoStew />} />
            <Route path="/puff" element={<Puff />} />
            <Route path="/tofu-wrap" element={<TofuWrap />} />
            <Route path="/banana-pancakes" element={<BananaPancakes />} />
            <Route path="/idli-platter" element={<IdliPlatter />} />
            <Route path="/mix-vegetable-curry" element={<MixVegetableCurry />} />
            <Route path="/chilli-butter-pasta" element={<ChilliButterPasta />} />
            <Route path="/key-lime-pie" element={<KeyLimePie />} />
            <Route path="/masala-chai" element={<MasalaChai />} />
            <Route path="/vegetable-cutlet" element={<VegetableCutlet />} />
            <Route path="/vanilla-milkshake" element={<VanillaMilkshake />} />
            <Route path="/vanilla-ice-cream" element={<VanillaIceCream />} />
            <Route path="/mango-pudding-weikfield" element={<MangoPuddingWeikfield />} />
            <Route path="/task-manager" element={<TaskManager />} />
            <Route path="/chorevault" element={<ChoreVault />} />
            <Route path="/sales-dashboard" element={<SalesDashboard />} />
            <Route path="/quizpopz" element={<QuizPopz />} />
            <Route path="/abacus" element={<Abacus />} />
            <Route path="/high-quality-games" element={<HighQualityGames />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/chat/adminlol" element={<ChatPage secretAdminOnly />} />
          </Routes>
        </div>
        {!isChat && !isQuizpopz && !isAbacus && <Footer />}
      </div>
  );
}

function App() {
  return (
    <Router>
      <AppFrame />
    </Router>
  );
}

export default App;
